
'use strict';

//Require Modules
var $ = require('jquery'),
  Backbone = require('backbone'),
  config = require('../../js/config'),
  mediator = require('../../js/mediator'),
  Analytics = require('../Analytics/Analytics'),
  LoaderView = require('../Loader/LoaderView'),
  LoginView = require('../../js/session/views/LoginView'),
  designCenter = require('./design-center'),
  session = require('../../js/session/index'),
  createProjectModalTmpl = require('./templates/create-project-modal.hbs'),
  globalisation = require('../../utilities/globalisation'),

  STATE_CLASS = {
    creating: 'CreateProjectModal--creating',
    loggedOut: 'CreateProjectModal--loggedOut',
    loading: 'CreateProjectModal--loading'
  };

Backbone.$ = $;

var CreateProjectModalView = Backbone.View.extend({

  initialize: function(options) {
    options = options || {};
    this.copyFromProject = options.copyFromProject;

    this.loaderView = new LoaderView();
    this.loginView = new LoginView();
    this.listenTo(designCenter.projectsController.model, 'change', this.updateUiState, this);
    this.listenTo(session.sessionController.model, 'change', this.updateUiState, this);
    this.listenTo(this, 'createProjectModal:closed', this.resetView, this);
    mediator.on(config.events.designCenter.createProjectFailed, this.createProjectFailed, this);
  },

  tagName: 'section',
  className: 'CreateProjectModal',
  currentProjectName: '',
  copyFromProject: null,
  isCreatingProject: false,
  hasCreateProjectFailed: false,
  lastServerError: null,
  minNameLength: 1,
  maxNameLength: 50,

  events: {
    'submit form': 'onFormSubmit',
    'click .CreateProjectModal-cancelButton': 'onCancel'
  },

  render: function() {
    this.$el.html(createProjectModalTmpl({ copyFromProject: this.copyFromProject }))
      .append(this.loaderView.el)
      .append(this.loginView.el);
    this.$form = this.$('.CreateProjectModal-createForm');
    this.$projectNameInput = this.$('.CreateProjectModal-nameInput');
    this.$errorMessage = this.$('.CreateProjectModal-errorMessage');
    this.loaderView.render();
    this.loginView.render();
    this.updateUiState();
    return this;
  },

  onFormSubmit: function(e) {
    e.preventDefault();
    var projectName = this.$projectNameInput.val();
    if (projectName && projectName.length >= this.minNameLength && projectName.length <= this.maxNameLength) {
      this.currentProjectName = projectName;
      this.hasCreateProjectFailed = false;
      this.lastServerError = null;
      this.removeError();
      if (this.copyFromProject) {
        mediator.trigger(config.events.designCenter.copyProject, projectName, this.copyFromProject);
      } else {
        mediator.trigger(config.events.designCenter.createProject, projectName);

        Analytics.pushToEventFramework({
          event: config.analytics.events.click,
          category: config.analytics.categories.designCenter,
          action: config.analytics.actions.createProject,
          label: config.analytics.labels.button
        });
      }
    } else {
      this.addError();
    }
  },

  onCancel: function(e) {
    e.preventDefault();
    // Sending event to the parent view (i.e popup modal, tooltip) to close it
    this.trigger('createProject:cancel');
  },

  resetView: function() {
    this.$projectNameInput.val('');
    this.removeError();
    this.currentProjectName = '';
    this.isCreatingProject = false;
    this.hasCreateProjectFailed = false;
    this.lastServerError = null;
  },

  addError: function() {
    var lengthRange = {
      min: this.minNameLength,
      max: this.maxNameLength
    };
    this.$projectNameInput.addClass(config.classes.isInvalid);
    this.$errorMessage.text(globalisation.pluraliseAndTranslate('commonValidation', 'lengthRangeError', lengthRange));
  },

  removeError: function() {
    this.$errorMessage.text('');
    this.$projectNameInput.removeClass(config.classes.isInvalid);
  },

  updateUiState: function() {
    if (session.sessionController.isLoggedIn() === false) {
      this.showLoggedOutStateUi();
    } else {
      // We presume the user can create a project and we'll handle a 401
      this.loginView.$el.hide();
      if (this.currentProjectName) {
        if (designCenter.projectsController.isCreatingProject(this.currentProjectName)) {
          this.showLoadingIndicatorUi();
        } else if (!this.isCreatingProject) {
          this.showCreateFormUi();
        }
      } else {
        this.showCreateFormUi();
      }
    }
  },

  setStateClass: function(stateClass) {
    this.$el
      .removeClass(STATE_CLASS.creating)
      .removeClass(STATE_CLASS.loggedOut)
      .removeClass(STATE_CLASS.loading);
    this.$el.addClass(stateClass);
  },

  // If we know for sure the user is not logged in
  // we might want to change this logic so that we ping the authorize
  // endpoint if we don't know using `mediator.trigger(config.events.session.checkLoggedInState)`
  showLoggedOutStateUi: function() {
    this.setStateClass(STATE_CLASS.loggedOut);
    // These JS hide/show can be handled by CSS when it's built
    this.loginView.$el.show();
    this.$form.hide();
    this.loaderView.$el.hide();
  },

  showLoadingIndicatorUi: function() {
    this.setStateClass(STATE_CLASS.loading);
    this.isCreatingProject = true;
    // These JS hide/show can be handled by CSS when it's built
    this.$form.hide();
    this.loaderView.$el.show();
  },

  showCreateFormUi: function() {
    this.setStateClass(STATE_CLASS.creating);
    if (this.hasCreateProjectFailed) {
      if (this.lastServerError && this.lastServerError.get('title')) {
        this.$errorMessage.text(this.lastServerError.get('title'));
      }
    }
    // These JS hide/show can be handled by CSS when it's built
    this.$form.show();
    this.loaderView.$el.hide();
  },

  createProjectFailed: function(projectName, err) {
    if (this.isCreatingProject && projectName === this.currentProjectName) {
      this.isCreatingProject = false;
      this.hasCreateProjectFailed = true;
      this.lastServerError = err;
    }
    this.updateUiState();
  }

});

module.exports = CreateProjectModalView;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/CreateProjectModalView.js